import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  reports: null,
  totalReports: 0,
  commodities: null,
  persistedFilters: {
    selectedClient: null,
    selectedProject: null,
    selectedLab: null,
  },
};

const reviewReportsSlice = createSlice({
  name: "reviewReports",
  initialState,
  reducers: {
     fetchReports(state) {
      state.loading = true;
      state.reports = null;
      state.totalReports = 0;
    },
    fetchReportsSuccess(state, action) {
      state.reports = action.payload.data.document;
      state.totalReports = action.payload.count;
      state.loading = false;
    },
    fetchReportsFailure(state, action) {
      state.loading = false;
    },
    fetchCommodities(state) {
      // state.loading = true;
    },
    fetchCommoditiesSuccess(state, action) {
      state.commodities = action.payload.data.document;
      // state.loading = false;
    },
    fetchCommoditiesFailure(state, action) {
      // state.loading = false;
    },
    
    setPersistedFilters: (state, action) => {
      state.persistedFilters = {
        ...state.persistedFilters,
        ...action.payload,
      };
    },
    
    clearPersistedFilters: (state) => {
      state.persistedFilters = initialState.persistedFilters;
    },
  },
});

export const { actions, reducer } = reviewReportsSlice;
